import { Seo } from "../components/site/Seo";
import { PageHero } from "../components/site/PageHero";
import { SectionHead } from "../components/site/Motion";
import { IconCard } from "../components/site/IconCard";
import { ProcessSteps } from "../components/site/ProcessSteps";
import { CTABand } from "../components/site/CTABand";
import { Marquee } from "../components/site/Marquee";
import { IMG } from "../content/site";
import { SERVICES } from "../content/services";

export default function ServicesPage() {
  return (
    <>
      <Seo title="Our Services" path="/services" description="Solar procurement advisory, energy requirement assessment, techno-commercial feasibility, proposal evaluation, developer and EPC identification, regulatory coordination and PPA facilitation." />
      <PageHero
        eyebrow="Our services"
        title={["From first assessment", "to signed agreement,", <span className="font-serif-i text-[#3f8a0f]">coordinated.</span>]}
        intro="Nine connected services that support C&I consumers and partners through each stage of a solar project."
        image={IMG.meeting}
        imageAlt="Advisory meeting discussing energy procurement"
      />
      <section className="bg-[#F9F8F3] py-24 md:py-32" data-testid="services-grid">
        <div className="mx-auto max-w-[1440px] px-5 md:px-10">
          <SectionHead eyebrow="What we offer" title={["Services built around", "your energy decision."]} />
          <div className="mt-16 grid auto-rows-fr gap-4 md:grid-cols-2 lg:grid-cols-3">
            {SERVICES.map((s, i) => <IconCard key={s.id} {...s} n={String(i + 1).padStart(2, "0")} i={i} />)}
          </div>
        </div>
      </section>
      <Marquee />
      <section className="bg-[#F2EFE7] py-24 md:py-32" data-testid="services-process">
        <div className="mx-auto max-w-[1440px] px-5 md:px-10">
          <SectionHead eyebrow="Engagement process" title={["How an engagement", "typically unfolds."]} />
          <div className="mt-16"><ProcessSteps /></div>
        </div>
      </section>
      <CTABand />
    </>
  );
}
